<template>
  <div
    v-if="isChangeButtonVisible"
    id="deleteOrderSection"
    class="columns-container container-spacing"
  >
    <div class="column" />
    <div class="column">
      <div class="change-order-page__header-right section-header">
        <h3>{{ i18n.t('/change-order/generic/cancel') }}</h3>
      </div>
      <div class="delete-order-container">
        <div>
          <div v-if="canShowDeleteButton">
            <app-button
              data-qa="enter-Add-Modee"
              :title="canDeleteOrderReason"
              @click="enterDeleteMode"
            >
              <i :class="determineChangedClass"></i>
              {{ i18n.t('/change-order/generic/cancel') }}
            </app-button>
          </div>
          <div v-else-if="showInput">
            <div class="delete-order-input-panel">
              <label class="label">{{ i18n.t('/change-order/generic/delete-confirm') }}</label>
            </div>
            <div class="cancellation-order-button-panel">
              <app-button data-qa="confirm-K-code" @click="confirmDeleteOrder">
                {{ i18n.t('/common/yes') }}
              </app-button>
              <app-button data-qa="cancel-Add-Mode" @click="cancelAddMode">
                {{ i18n.t('/common/no') }}
              </app-button>
            </div>
          </div>
          <div v-else>
            <span v-if="hasDeletedOrder" class="confirmation-message">
              <i class="fas fa-arrows-rotate"></i>&nbsp;
              <strong>
                {{ i18n.t('/change-order/generic/modified') }}
              </strong>
              &nbsp; {{ i18n.t('/change-order/generic/modified-confirmation') }}
            </span>
            <div class="delete-order-panel">
              <div>
                <label class="label">
                  {{ i18n.t('/change-order/generic/delete-warning') }} &nbsp;
                </label>
              </div>
              <div class="cancellation-order-button-panel">
                <app-button data-qa="enter-edit-mode" @click="enterEditMode">
                  <i class="fas fa-pencil-alt"></i>&nbsp;
                  {{ i18n.t('/edit button label') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import ChangeOrderStatus from '@/helpers/enums/changeOrderStatus'
import { mapGetters } from 'vuex'

export default {
  components: { AppButton },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showDeleteButton: true,
      showInput: false,
      canDeleteOrderInput: '',
    }
  },
  computed: {
    ...mapGetters({
      changeOrder: 'changeOrder/get',
      dealerSettings: 'user/dealerSettings',
    }),
    isChangeButtonVisible() {
      return this.dealerSettings.isImporter
    },
    canDeleteOrder() {
      return (
        this.changeOrder.MainOrderStatus !== ChangeOrderStatus.submitted &&
        this.changeOrder.MainOrderStatus !== ChangeOrderStatus.archived &&
        this.changeOrder.Permissions.CanDeleteOrder.Allowed === true
      )
    },
    canDeleteOrderReason() {
      return this.changeOrder?.Permissions?.CanDeleteOrder?.Reason
    },
    determineChangedClass() {
      if (this.canDeleteOrder) {
        return 'fa-solid fa-pencil'
      } else {
        return 'fa-solid fa-lock'
      }
    },
    canShowDeleteButton() {
      return this.showDeleteButton && this.changeOrder.IsCanDeleteOrder === false
    },
    hasDeletedOrder() {
      return (
        (this.changeOrder.MainOrderStatus !== ChangeOrderStatus.submitted ||
          this.changeOrder.MainOrderStatus !== ChangeOrderStatus.archived) &&
        this.changeOrder.IsCanDeleteOrder
      )
    },
  },
  methods: {
    enterDeleteMode() {
      if (this.canDeleteOrder) {
        this.showDeleteButton = false
        this.showInput = true
      }
    },
    cancelAddMode() {
      this.showDeleteButton = true
      this.showInput = false
      this.canDeleteOrderInput = false
      this.changeOrder.IsCanDeleteOrder = false
    },
    enterEditMode() {
      this.canDeleteOrderInput = this.changeOrder.IsCanDeleteOrder
      this.enterDeleteMode()
    },
    removeCancellationOrder() {
      this.changeOrder.IsCanDeleteOrder = false
      this.canDeleteOrderInput = false
      this.showDeleteButton = true
    },
    confirmDeleteOrder() {
      this.canDeleteOrderInput = true
      this.changeOrder.IsCanDeleteOrder = true
      this.showInput = false
    },
  },
}
</script>
<style lang="scss" scoped>
.columns-container {
  display: flex;
  justify-content: space-between;
}

.container-spacing {
  margin-top: 50px;
}

.column {
  flex: 1;
  margin: 0 20px;
}

h3 {
  font-weight: 400;
  margin: 0;
}

.change-order {
  &-page__header-left {
    h3 {
      color: $black;
    }
  }

  &-page__header-right {
    h3 {
      color: $color-primary;
    }
  }
}

.section-header {
  border-bottom: 1px solid #a3b8c0;
  align-items: center;
  margin-bottom: 1rem;
}

.delete-order-container {
  margin-top: 40px;
  margin-bottom: 70px;
}

.confirmation-message {
  background-color: #ffdd9c;
  font-size: 18px;
  padding: 10px;
}

.delete-order-input-panel {
  label {
    font-weight: bold;
    margin-bottom: 3px;
  }
  input {
    margin-left: 10px;
    height: 20px;
    width: 20px;
  }
}

.delete-order-panel {
  margin-top: 20px;
  label {
    font-weight: bold;
    margin-bottom: 2px;
  }
  span {
    padding: 5px;
  }
}

.cancellation-order-button-panel {
  margin-top: 20px;
}
</style>
